import { http, createConfig } from 'wagmi';
import { base } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

// WalletConnect project ID (optional - enables WalletConnect QR for mobile wallets)
// For now, using injected-only (MetaMask, Rabby, Coinbase Wallet extension, etc.)
// const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;

const connectors = [injected()];

export const wagmiConfig = createConfig({
  chains: [base],
  connectors,
  transports: {
    [base.id]: http(),
  },
});
